module.exports = __webpack_public_path__ + "static/img/banner1.b9a6ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner1.png
// module id = dfbp
// module chunks = 2